import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  Button,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import skrill from "../../images/SkrillLogo.png";
import "./infoStyle.css";
import { Link } from "react-router-dom";
import { endPoints, PaymentEndpoints } from "../../constant/Environment";
import { useSelector, useDispatch } from "react-redux";
import { setFreeSpinGames, setLoading } from "../../redux/Reducers/GlobalReducer/globalSlice";
import { useSnackbarContext } from "../../component/SnackbarContext";
import { getAllData, addData, addBetData } from "../../Utility/API";
import { SkrillEnv } from "../../constant/SkrillEnv";
import Loader from "../../component/Loader";
import { useNavigate } from "react-router-dom";
import LocationWarningModal from "../LocationWarningModal";
import { formatCurrencyAmount } from "../../Utility/currencyDisplay";
import { isTestPaymentMode, generateTestReferenceId } from "../../Utility/testPayment";
const PaymentButton = (props) => {
  const {
    // open,
    // onClose,
    // selecteNewPackage,
    item,
    getCoinPackageList,
    GetUserById,
    className,
    allowOnPress = false,
    handleOnPress,
    showPayNow = false,
    closeModal,
    style,
  } = props;
  const [locationModal, setLocationModal] = useState(false); // location modal
  const theme = useTheme();
  // console.log("selecteNewPackage", selecteNewPackage);
  //   const { goldcoins, purchase_price } = selecteNewPackage;
  const loginData = useSelector((state) => state.auth.IsLoginData);
  const authState = useSelector((state) => state.auth);

  const { isAuthenticated, isUserInAllowedRegion } = authState;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbarContext();
  const selecteNewPackage = {};

  const resolveApiErrorMessage = (errorLike, fallback) => {
    return (
      errorLike?.response?.data?.message ||
      errorLike?.data?.message ||
      errorLike?.message ||
      fallback
    );
  };
  const payBySkrill = (item) => {
    if (item) {
      // Dev/stage: skip the real gateway and run the test payment instead.
      if (isTestPaymentMode()) {
        payByTest(item);
        return;
      }
      const merchantRefNum = RandomRefNum(`spinsaga_${loginData?.idUser}`);
      SavePackageInfo(item.purchase_price, merchantRefNum, item);
    }
  };

  // Simulated purchase (dev/stage only). Auto-generates a unique referenceId,
  // hits the backend test-payment API, then refreshes like the real success branch.
  const payByTest = async (item) => {
    const referenceNo = generateTestReferenceId(loginData?.idUser);
    const url = `${PaymentEndpoints.apiBaseUrl}${PaymentEndpoints.api.TEST_PAYMENT}`;
    const data = {
      userId: loginData?.idUser,
      packageId: item.id,
      referenceId: referenceNo,
      currency: item.currency || "USD",
    };
    try {
      dispatch(setLoading(true));
      const response = await addBetData(url, data);
      if (response?.data?.status == "success") {
        try {
          window.dispatchEvent(new CustomEvent("popup:trigger", { detail: { trigger: "post_purchase" } }));
          sessionStorage.removeItem("popup_shop_visits");
        } catch (e) { /* never break the payment flow over a popup trigger */ }
        showSuccessSnackbar(response?.data?.message || "Test payment completed.");
        GetUserById();
        getCoinPackageList();
        if (typeof closeModal === "function" || showPayNow) {
          closeModal();
        }
        navigate("/buy-coins?payment=success", { replace: true });
      } else {
        showErrorSnackbar(
          resolveApiErrorMessage(response, "Test payment failed.")
        );
      }
    } catch (err) {
      console.log(err);
      showErrorSnackbar(
        "Issue connecting to server (error code 15). Please contact support for further assistance."
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

  const RandomRefNum = (prefix) => {
    const randomNum = Math.floor(Math.random() * 900000) + 100000;
    return `${prefix}_${randomNum}`;
  };

  const applePay = {
    accountId: SkrillEnv.accountId,
    // "1002783170",
    label: "Pay With Apple",
    requestShippingAddress: true,
    requestBillingAddress: false,
    type: "buy",
    color: "white-outline",
  };

  const notApplePay = {};
  const resultApplePay = applePay;

  const SavePackageInfo = async (
    depositamount,
    referenceNo,
    selectedPackage
  ) => {
    console.log("🚨 SENDING packageId 👉", selectedPackage?.id);
    const amountInCents = Math.round(Number(depositamount) * 100);
    let url = `${PaymentEndpoints.apiBaseUrl}${PaymentEndpoints.api.SKRILL_ADD}`;
    setLoading(true);
    let data = {
      id_skrill_wallet_transaction: 0,
      merchantRefNum: referenceNo,
      id_user: loginData?.idUser,
      amount: amountInCents,
      currencyCode: selectedPackage.currency || "USD",
      paymentHandleToken: "",
      pay_from_email: "",
      bonus_amount: selectedPackage.bonus_amount,
      package_amount: selectedPackage.package_amount,
      packagename: selectedPackage.package_name,
      packageId: selectedPackage.id,
    };
    try {
      let response = await addBetData(url, data);
      console.log("🔥 /addpayment RESPONSE:", response);
      if (response?.data?.status == "success") {
        // onClose();
        // `${SkrillEnv.keys}`;
        // skrill modal script
        console.log("👉 Customer Data:", {
          email: loginData?.email,
          firstName: loginData?.firstName,
          lastName: loginData?.lastName,
        });
        window.paysafe.checkout.setup(
          SkrillEnv.keys,
          // {
          //   currency: "USD",
          //   amount: amountInCents,
          //   payout: false,
          //   locale: "en_US",
          //   ...(SkrillEnv.Env === "TEST" ? { simulator: "EXTERNAL" } : {}),
          //   environment: SkrillEnv.Env,
          //   customer: {
          //     email: loginData?.email,
          //   },
          //   merchantRefNum: referenceNo,
          //   canEditAmount: false,
          //   displayPaymentMethods: ["skrill"],
          //   paymentMethodDetails: {
          //     skrill: {
          //       // consumerId: `spinsaga_${loginData?.idUser || "guest"}`,
          //       customer: {
          //         email: loginData?.email || "test@email.com",
          //         firstName:
          //           loginData?.firstName && loginData.firstName.trim().length > 0
          //             ? loginData.firstName
          //             : "Test",
          //         lastName:
          //           loginData?.lastName && loginData.lastName.trim().length > 0
          //             ? loginData.lastName
          //             : "User",
          //         },
          //     },
          //   },
          // },
          
          {
          currency: "USD",
          amount: amountInCents,
          payout: false,
          locale: "en_US",
          environment: SkrillEnv.Env,

          customer: {
            firstName: "John",
            lastName: "Doe",
            email: "john.doe@email.com",
          },

          billingAddress: {
            street: "100 Queen Street",
            city: "Toronto",
            state: "ON",
            country: "CA",
            zip: "M5H2N2",
          },

          merchantRefNum: referenceNo,
          canEditAmount: false,

          displayPaymentMethods: ["skrill"],

          paymentMethodDetails: {
            skrill: {
              consumerId: `spinsaga_${loginData?.idUser || "guest"}`,
            },
          },
        },
          function (instance, error, result) {
            console.log("🔥 CALLBACK START");

            console.log("👉 FULL RESULT:", JSON.stringify(result, null, 2));
            console.log("👉 FULL ERROR:", JSON.stringify(error, null, 2));

            if (!result) {
              console.error("❌ RESULT IS NULL");
            }

            if (error) {
              console.error("❌ ERROR RECEIVED:", error);
            }

            if (result && result.paymentHandleToken) {
              console.log("✅ TOKEN FOUND:", result.paymentHandleToken);
            } else {
              console.error("❌ NO TOKEN FOUND IN RESULT");
            }
            console.log("🔥 Skrill Result:", result);
            console.log("result", result, "error", error);
            if (result && result.paymentHandleToken) {
              setLoading(false);
              instance?.close?.();
              SkrillPay(
                result?.amount,
                referenceNo,
                result?.paymentHandleToken,
                selectedPackage
              );
            } else if (error) {
              setLoading(false);
              instance?.close?.();
              console.error("Skrill checkout error", error, result);
              showErrorSnackbar(
                error?.message ||
                  error?.detailedMessage ||
                  "There was an error processing Skrill checkout. Please try again."
              );
            } else {
              setLoading(false);
            }
            if (result?.token) {
              //alert(""Payment Token (Returned By Paysafe GW): "" + result.token);
              console.log(result.token);
              // pass this token to server to make the payment or payout using Paysafe Payments API.
            }
          },
          function (stage, expired) {
            setLoading(false);
            switch (stage) {
              case "PAYMENT_HANDLE_NOT_CREATED": // Handle the scenario
              case "PAYMENT_HANDLE_CREATED": // Handle the scenario
              case "PAYMENT_HANDLE_REDIRECT": // Handle the scenario
              case "PAYMENT_HANDLE_PAYABLE": // Handle the scenario
              default: // Handle the scenario
            }
          },
          function (instance, amount, paymentMethod) {
            setLoading(false);
            // use parameters amount and payment method to do riskCheck
            // Applicable to only Cards, PaySafe Cash, VIPP and Sightline
            if (amount == 2000) {
              instance.decline("Please use amount less than 100");
              // showErrorSnackbar("Please use amount less than 100");
            } else {
              instance.accept();
            }
          }
        );
      } else {
        showErrorSnackbar(
          resolveApiErrorMessage(
            response,
            "Issue connecting to server (error code 15). Please contact support for further assistance."
          )
        );
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      showErrorSnackbar(
        resolveApiErrorMessage(
          err,
          "Issue connecting to server (error code 15). Please contact support for further assistance."
        )
      );
    }
  };

      const fetchFreeSpinGames = async () => {
              try {
                const url = `${endPoints.api.RECENT_FREE_SPIN_GAMES}/${loginData.idUser}`;
                const response = await getAllData(url);
                
                if (response?.status === "success" && response?.data) {
                  dispatch(setFreeSpinGames(response.data));
                }
              } catch (error) {
                console.error("Error fetching free spin games:", error);
                dispatch(setFreeSpinGames([]));
              }
      };

  const SkrillPay = async (
    depositamount,
    referenceNo,
    tokenId,
    selectedPackage
  ) => {
    let url = `${PaymentEndpoints.apiBaseUrl}${PaymentEndpoints.api.DEPOSIT_PAYMENT}`;

    let data = {
      merchantRefNum: referenceNo,
      // amount: depositamount,
      amount: Number(depositamount),
      id_user: loginData?.idUser,
      accountId: "284006353",
      paymentHandleToken: tokenId,
      currencyCode: "USD",
      settleWithAuth: true,
      bonus_amount: selectedPackage?.bonus_amount,
      package_amount: selectedPackage?.package_amount,
      packagename: selectedPackage?.package_name,
      pakageId: selectedPackage?.id,
    };
    try {
      setLoading(true);
      console.log("🔥 CALLING /payment API");
      console.log("🔥 URL:", url);
      console.log("🔥 REQUEST DATA:", data);
      let response = await addBetData(url, data);
      console.log("🔥 BACKEND RESPONSE:", response);
      if (response?.data?.status == "success") {
        try {
          window.dispatchEvent(new CustomEvent("popup:trigger", { detail: { trigger: "post_purchase" } }));
          sessionStorage.removeItem("popup_shop_visits");
        } catch (e) { /* never break the payment flow over a popup trigger */ }
        showSuccessSnackbar(response?.data?.message);
        GetUserById();
        getCoinPackageList();
        fetchFreeSpinGames();
        if (typeof closeModal === "function" || showPayNow) {
          closeModal();
        }
        navigate("/buy-coins?payment=success", { replace: true });
      } else {
        showErrorSnackbar(
          resolveApiErrorMessage(
            response,
            "Issue connecting to server (error code 15). Please contact support for further assistance."
          )
        );
      }
    } catch (err) {
      // console.log(err);
      console.error("🔥 PAYMENT ERROR:", err?.response || err);
      showErrorSnackbar(
        resolveApiErrorMessage(
          err,
          "Issue connecting to server (error code 15). Please contact support for further assistance."
        )
      );
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const SkrillFailed = async (depositamount, referenceNo) => {
    // First line so the trigger fires even if everything downstream throws.
    try {
      window.dispatchEvent(new CustomEvent("popup:trigger", { detail: { trigger: "payment_failed" } }));
    } catch (e) { /* never break the payment flow over a popup trigger */ }
    let url = `${PaymentEndpoints.apiBaseUrl}${PaymentEndpoints.api.FAILED_DEPOSIT}`;

    let data = {
      merchantRefNum: referenceNo,
      amount: depositamount,
      id_user: loginData?.idUser,
      accountid: "string",
      paymentHandleToken: "string",
      currencyCode: "string",
      settleWithAuth: "string",
      status: "string",
      description: "string",
      tstatus: 0,
    };
    try {
      setLoading(true);
      let response = await addBetData(url, data);
      setLoading(false);
      if (response?.data?.status == "success") {
        showSuccessSnackbar(response?.data?.message);
        GetUserById();
        getCoinPackageList();

        if (typeof closeModal === "function" || showPayNow) {
          closeModal();
        }
      } else if (response?.data?.status == "failure") {
        showErrorSnackbar(
          resolveApiErrorMessage(
            response,
            "Issue connecting to server (error code 15). Please contact support for further assistance."
          )
        );
      } else {
        showErrorSnackbar(
          resolveApiErrorMessage(
            response,
            "Issue connecting to server (error code 15). Please contact support for further assistance."
          )
        );
      }
    } catch (err) {
      console.log(err);
      showErrorSnackbar(
        resolveApiErrorMessage(
          err,
          "Issue connecting to server (error code 15). Please contact support for further assistance."
        )
      );
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {locationModal && (
        <LocationWarningModal
          open={locationModal}
          onClose={() => {
            setLocationModal(false);
          }}
        />
      )}
      {loading && <Loader loading={loading} />}
      <Button
        size="small"
        style={style}
        sx={{
          background: theme.palette.custom.red,
          color: theme.palette.custom.white,
        }}
        className={className}
        disabled={item?.isDisabled}
        onClick={() => {
          //   handleOpen(item);
          if (isAuthenticated) {
            if (isUserInAllowedRegion) {
              setLocationModal(true);
              return;
            }
            if (allowOnPress) {
              handleOnPress(item);
            } else {
              payBySkrill(item);
            }
          } else {
            navigate("/login");
          }
          // allowOnPress ? handleOnPress(item) :
        }}
      >

        {showPayNow ? "Skrill Pay" : `${item.purchase_price}`}
        {/* {showPayNow ? "Skrill Pay" : formatCurrencyAmount(item.purchase_price, item.currency || loginData?.currency)} */}
        {/* {item.purchase_price} */}
      </Button>
    </>
  );
};

export default PaymentButton;
